import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { routes } from './app.routes';
import { provideClientHydration, withNoIncrementalHydration } from '@angular/platform-browser';
import { provideNativeDateAdapter, MAT_DATE_LOCALE, MatDateFormats } from '@angular/material/core';

import { authSalesforceInterceptor } from './interceptors/auth-salesforce-interceptor.interceptor';

const DATE_FORMATS: MatDateFormats = {
  parse: {
    dateInput: null,
  },
  display: {
    dateInput: { year: 'numeric', month: '2-digit', day: '2-digit' },
    monthYearLabel: { year: 'numeric', month: 'short' },
    dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
    monthYearA11yLabel: { year: 'numeric', month: 'long' },
  },
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
        anchorScrolling: 'enabled',
      })
    ),
    provideClientHydration(withNoIncrementalHydration()),
    provideHttpClient(withFetch(), withInterceptors([authSalesforceInterceptor])),
    provideNativeDateAdapter(DATE_FORMATS),
    { provide: MAT_DATE_LOCALE, useValue: 'es-MX' },
  ],
};
